import * as React from 'react';
import { withRouter , BrowserHistory } from "react-router-dom";
import NavHeader from '../NavHeader/NavHeader';
import NavFooter from '../NavFooter/NavFooter';
import "./static/NavDrawer.scss";
class NavDrawer extends React.Component< 
{items: Array<{title: string, onClick: Function}>, 
user: string, organisationName: string,
history: BrowserHistory}, {}> {
    render() {
        return (
            <div className='sidebar'>
                <NavHeader name={this.props.user} organisationName={this.props.organisationName} />
                <nav>
                    {
                        this.props.items.map(
                            (item, index) => 
                            item.title
                        )
                    }
                    
                </nav>
                <NavFooter />
            </div>
        );
    }
}
export default withRouter(NavDrawer);


// WEBPACK FOOTER //
// ./src/component/NavDrawer/NavDrawer.tsx